module.exports = __webpack_public_path__ + "img/dispatch-p4.8b14f7ab.jpg";